import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Parser from 'html-react-parser'
import messages from './messages'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import InfoBox from '../InfoBox'

const v4 = css`
    margin: 0;

  .list-group-item-div {
    display: flex;
    align-items: center;
    background: none;
    border: none;
    padding: 0;
  }
  .list-group-item-div.active {
    background: none;
  }
  .listItemText {
    border: 2px solid var(--clr-grey-7-to-text);
    padding: 15px;
    margin-left: 1.5rem;
    width: calc(100% - 3rem);
    font-size: unset;
    color: var(--clr-accent-to-text);
  }
  .listItemText.active {
    border: 1px solid var(--clr-black-to-text);
    border-left: 5px solid var(--clr-main);
  }
  .circle,
  .circle.active,
  .circle.already-complete {
    position: unset;
    border: none;
    background: none;
    color: #000;
    font-size: var(--h3);
    transform: none;
  }
`

const ListItem = styled.li`
    position: relative;
    display: block;
    padding: 5px 0px 12px;
    margin-top: 8px;
    background-color: transparent;
    margin-bottom: 15px;
    border: none;
    color: var(--clr-grey-3-to-text);

  .list-group-item-div {
    border: 1px solid var(--clr-grey-6-to-text);
    padding: 20px;
    border-top-left-radius: 20px;
  }
  .list-group-item-div.active {
    color: var(--clr-accent-to-black);
    background: var(--clr-grey-7-to-text);
  }
  #step-active > .list-group-item-div {
    border: none;
  }
  .listItemText {
    margin-left: 40px;
    font-size: clamp(0.9rem, 1.4vw, 1.1rem);
  }
  .circle {
    width: 40px;
    height: 40px;
    background: var(--clr-white-to-bg);
    border: 1px solid var(--clr-grey-6-to-text);
    position: absolute;
    top: 20px;
    left: 0px;
    transform: translateY(-50%);
    border-radius: 50%;
    text-align: center;
    color: var(--grey-6);
    font-size: var(--small-icon-size);
    font-weight: 700;
  }
  .circle.active {
    background-color: var(--clr-accent);
    border-color: var(--clr-accent);
    color: var(--clr-text-on-button);
  }
  .circle.already-complete {
    background-color: var(--clr-grey-5-to-bg);
    border-color: var(--grey-5);
    color: var(--clr-white-to-text);
  }
  ${props => props.version === 'v4' && v4}
`

const proptypes = {
  text: PropTypes.string.isRequired,
  updateStep: PropTypes.func.isRequired,
  active: PropTypes.bool,
  alreadyComplete: PropTypes.bool,
  openMobileDevice: PropTypes.func,
  lastStep: PropTypes.bool,
  stepNum: PropTypes.number.isRequired,
  language: PropTypes.string.isRequired,
  stepArrayLoc: PropTypes.number.isRequired,
  interactive: PropTypes.bool.isRequired,
  createUserEvent: PropTypes.func.isRequired,
  currentTutorialId: PropTypes.number.isRequired,
  automatedStep: PropTypes.func.isRequired,
  playStepAnimation: PropTypes.func.isRequired,
  version: PropTypes.string.isRequired,
  currentPhoneId: PropTypes.number.isRequired
}

const TutorialStep = ({
  text,
  active,
  alreadyComplete,
  stepNum,
  openMobileDevice,
  lastStep,
  language,
  stepArrayLoc,
  interactive,
  createUserEvent,
  currentTutorialId,
  updateStep,
  automatedStep,
  playStepAnimation,
  version,
  currentPhoneId
}) => {
  const translated = messages[language]
  const isActive = active ? 'active' : ''
  const circleClass = active
    ? 'active'
    : alreadyComplete
    ? 'already-complete'
    : ''
  const stepID = active ? 'step-active' : ''

  const tutorialUpdateStep = step => {
    createUserEvent({
      category: 'tutorials',
      data: {
        action: 'OnStepTextClick',
        target: currentTutorialId,
        step_to: step,
        device_id: currentPhoneId
      }
    })
    updateStep(step)
    if (step === automatedStep()) {
      playStepAnimation()
    }
  }
  return (
    <ListItem
      itemProp="itemListElement"
      itemScope
      itemType="http://schema.org/HowToStep"
      className="pointer list-group-item"
      id={stepID}
      onClick={() => tutorialUpdateStep(stepArrayLoc)}
      version={version}
    >
      <div className={`list-group-item-div ${isActive}`}>
        <div className={`circle ${circleClass}`}>{stepNum}</div>
        <div className={`listItemText ${isActive}`}>
          {text &&
            Parser(text, {
              replace: domNode => {
                if (!domNode || !domNode.name || domNode.name !== 'span') return
                if (domNode.attribs.class === 'explanation') {
                  return (
                    <InfoBox node={domNode} icon="categories/information.svg" />
                  )
                }
              }
            })}
        </div>
      </div>
      {!lastStep && interactive && (
        <a onClick={openMobileDevice} className="mobile-image-link">
          {translated.image}
        </a>
      )}
    </ListItem>
  )
}

TutorialStep.propTypes = proptypes

export default LanguageProvider(TutorialStep)



// WEBPACK FOOTER //
// ./src/components/TutorialStep/TutorialStep.js